var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"bottomSection",class:[
    'w-full box-border',
    !_setup.isStream && !_setup.isSlideshow && !_setup.isExpanded && 'ps-3 pe-2 py-2',
    _setup.isStream && !_setup.isSlideshow ? 'px-4 py-2' : _setup.isExpanded && 'p-2',
    _setup.isSlideshow && [
      {
        'ps-9 pe-5 py-5': _vm.pollScaleMultiplier === 2.5,
        'ps-7 pe-4 py-4': _vm.pollScaleMultiplier === 2,
        'ps-6 pe-2 py-2': _vm.pollScaleMultiplier === 1,
        'bg-white-100': _setup.darkMode === false,
        'bg-nightfall-900': _setup.darkMode === true,
        'bg-white-100 dark:bg-nightfall-900': _setup.darkMode === 'auto',
      },
    ],
    _setup.isExpanded || _setup.isSlideshow ? 'min-h-12' : 'min-h-10',
    _setup.isExpanded || _setup.isSlideshow ? 'items-start' : 'items-center',
    _setup.contentTooWide ? 'flex flex-col space-y-3' : 'flex flex-wrap justify-between',
  ],on:{"dblclick":function($event){if($event.target !== $event.currentTarget)return null;return _vm.$emit('dblclick', $event)}}},[_c('div',{class:[
      _setup.isStream ? 'text-body-small' : 'text-body-extra-small',
      _setup.contentTooWide ? 'flex flex-col items-start w-full space-y-3' : 'flex flex-wrap items-center space-x-1',
      {
        'text-dark-text-200': _setup.darkMode === false,
        'text-light-text-200': _setup.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
      },
    ]},[_c('span',{attrs:{"data-testid":"surfacePostPollVoteCount"}},[_vm._v("\n      "+_vm._s(_setup.n__('%{totalVotesCount} vote', '%{totalVotesCount} votes', _setup.totalVotesCount, {
          totalVotesCount: _setup.totalVotesCount,
        }))+"\n    ")]),_vm._v(" "),(_setup.xResultsToggle)?[(!_setup.contentTooWide)?_c('span',{class:[
          'font-semibold',
          {
            'text-dark-text-300': _setup.darkMode === false,
            'text-light-text-300': _setup.darkMode === true,
            'text-dark-text-300 dark:text-light-text-300': _setup.darkMode === 'auto',
          },
        ]},[_vm._v("•")]):_vm._e(),_vm._v(" "),_c(_setup.OzPlainButton,{class:[
          'font-semibold rounded-xl hover-hover:focus-visible:ring-2 px-0',
          {
            'text-dark-text-200': _setup.darkMode === false,
            'text-light-text-200': _setup.darkMode === true,
            'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
          },
        ],attrs:{"tabindex":0,"dark-mode":_setup.darkMode,"text":_setup.isShowingPollResults ? _setup.__('Hide Results') : _setup.__('Show Results'),"color-scheme":_setup.OzPlainButtonColorScheme.Secondary,"size-preset":_setup.OzPlainButtonSizePreset.Bare},on:{"click":_setup.togglePollResults,"pointerdown":function($event){$event.stopPropagation();}}})]:(_setup.isPollClosed)?[(!_setup.contentTooWide)?_c('span',{class:{
          'text-dark-text-300': _setup.darkMode === false,
          'text-light-text-300': _setup.darkMode === true,
          'text-dark-text-300 dark:text-light-text-300': _setup.darkMode === 'auto',
        }},[_vm._v("•")]):_vm._e(),_vm._v(" "),_c('span',{class:{
          'text-dark-text-200': _setup.darkMode === false,
          'text-light-text-200': _setup.darkMode === true,
          'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
        },attrs:{"data-testid":"surfacePostPollClosedText"}},[_vm._v("\n        "+_vm._s(_setup.__('Poll closed'))+"\n      ")])]:_vm._e()],2),_vm._v(" "),(_setup.xVoteButton)?_c(_setup.OzContainedButton,{class:['no-drag', _setup.contentTooWide && 'w-full'],attrs:{"data-testid":"surfacePostPollVoteButton","size-preset":_setup.isSlideshow || _setup.isExpanded || _setup.isStream ? _setup.OzContainedButtonSizePreset.H32px : _setup.OzContainedButtonSizePreset.H24px,"dark-mode":_setup.darkMode,"text":_setup.__('Vote'),"label":_setup.__('Vote'),"disabled":_setup.isVoteButtonDisabled},on:{"click":function($event){$event.stopPropagation();return _setup.emit('vote')},"pointerdown":function($event){$event.stopPropagation();}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }